<template>
  <div>
    <div style="width: 100%">
      <div style="width: 100%">
        <div class="goodsDetail_header_inner" style="margin-top: 20px;height: 40px;display: flex;align-items: center;">
          <div style="font-size: 18px; width: 1400px; margin: 0 auto; color: #515a6e">
            <i class="el-icon-s-home"></i>{{ $t("Home") }} >{{ $t("Series") }}
          </div>
        </div>
        <div class="disQueryUl">
          <div class="title" style="margin-right: 15px;">
            <span style="padding: 5px;">{{ $t("选购类型") }}:</span>
          </div>
          <div v-for="(item, index) in typeList" :key="index">
            <span v-if="queryData.typeId == item.id" class="hoverCls" @click="tolink(item.id)">
              {{ item.nameX }}
            </span>
            <span v-else @click="tolink(item.id)">
              {{ item.nameX }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="buy_conter">
      <div class="buy_conter_left">
        <div class="bcl_box" v-if="i1.length > 0">
          <p class="title">{{ $t("陈列参考") }}</p>
          <div class="bcl_box_img">
            <!-- 轮播图片 -->
            <el-carousel height="230px" :interval="0" arrow="always">
              <el-carousel-item v-for="(item, index) in i1" :key="index">
                <!-- <img :src="`${item}`" width="335" height="230" alt=""> -->
                <viewer>
                  <img 
                    :src="`${item}`" width="335" height="230" 
                    class="mr-3" alt="..." style="cursor: pointer" />
                </viewer>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="bcl_box" v-if="i2.length > 0">
          <p class="title">{{ $t("宣传资料") }}</p>
          <div class="bcl_box_img">
            <!-- 轮播图片 -->
            <el-carousel height="230px" :interval="0" arrow="always">
              <el-carousel-item v-for="(item, index) in i2" :key="index">
                <viewer>
                  <img 
                    :src="`${item}`" width="335" height="230" 
                    class="mr-3" alt="..." style="cursor: pointer" />
                </viewer>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="bcl_box" v-if="i3.length > 0">
          <p class="title">{{ $t("陈列货架") }}</p>
          <div class="bcl_box_img">
            <!-- 轮播图片 -->
            <el-carousel height="230px" :interval="0" arrow="always">
              <el-carousel-item v-for="(item, index) in i3" :key="index">
                <viewer>
                  <img 
                    :src="`${item}`" width="335" height="230" 
                    class="mr-3" alt="..." style="cursor: pointer" />
                </viewer>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <div class="buy_conter_right">
        <div class="buy_conter_right_title">
          Qty:{{ typeDataTitle.num }}
          &nbsp;
          Subtotal:{{ typeDataTitle.price }}
          <a href="#" @click="BuyAllToCart">
            All Add to Cart
          </a>
        </div>
        <ul v-for="(item, index) in goodsList" :key="index">
          <li v-for="(skuarr,i2) in item" :key="i2">
            <div>
              <img @click="toGoUrl(skuarr)" width="310" :src="`https://hwimg.xmvogue.com/thumb/${skuarr.item_no}.jpg?x-oss-process=style/440`">
            </div>
            <div>
              <div class="goods_name_div">
                <span style="color: #000000; font-size: 14px; margin-right: 5px;">
										{{ skuarr.item_no }}
									</span>
                <i class="el-icon-document-copy" v-clipboard:copy="skuarr.item_no" v-clipboard:success="onCopy"
                   v-clipboard:error="onError"></i>
              </div>
              <div class="goods_name_div">
                {{ (lang === "zh-CN" ? skuarr.item_name : skuarr.item_en) | cutstr }}
              </div>

              <div class="price_div">
                <p>
                  <span class="price_unit">{{ $t("Wholesale price") }}:</span>
                  <span class="price"> {{ $t("Price symbol") }}{{ skuarr.base_price.toFixed(2) }}</span>
                </p>
                &nbsp;
                <p>
                  <span class="price_unit">{{ $t("Retail Price") }}:</span>
                  <span class="price">{{ $t("Price symbol") }}{{ skuarr.sale_price.toFixed(2) }}</span>
                </p>
              </div>
              <div class="add_num_div">
                <el-input-number v-model="skuarr.addNum" :min="skuarr.purchase_spec" :max="999999" :step="skuarr.purchase_spec" />
              </div>
              <div class="add_to_cart">
                <a  @click="addCarts(skuarr)">{{ $t("Add to Cart") }}</a>
                <span v-if="skuarr['user_cart_info']">[{{ skuarr.user_cart_info.num }}]</span>
                <span v-else>[0]</span>
                <i class="el-icon-delete" style="margin-left: 8px" @click="delteCartGoods(skuarr.item_no)"></i>
              </div>
            </div>
          </li>
        </ul>

        <!--  分页  -->
        <div class="pagination">
          <el-pagination background :current-page="queryData.page" :page-size="queryData.pageSize" layout="total, prev, pager, next" :total="queryData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import common from "@/common/mixins/common.js";
import { AddToCartByGoods,DeleteGoods2Carts } from "@/api/carts/carts.js";
import { GetBuyType, GetGoodsList, AllToCart,GetGoodsPriceAndNum } from "@/api/goods/buy.js";
import { Loading } from "element-ui";

export default {
  mixins: [common],
  components: {
    // Footer,
    // QUERY,
  },
  data() {
    return {
      num: [],
      goodsList: [],
      typeData:{},
      typeDataTitle:{
        "price": 0,
        "num": 0,
      }, // 类型数据标题
      typeList: [
        {
          id: 1,
          name: "IPV6",
        },
      ],
      queryData: {
        typeId: 0,
        page: 1,
        pageSize: 12,
        total: 0,
      },
      lang: this.$i18n.locale,
      showTypeData: {},
      i1: [],
      i2: [],
      i3: [],
    };
  },
  watch: {
    "queryData.typeId"() {
      this.getList();
      //获取到该类型在线数量及价格
      this.getPriceAndNum();
    },
    showTypeData() {
      this.showImgList();
    },
    // 监听路由参数的变化，重新请求数据
    $route(to, from) {
      this.queryData.typeId = this.$route.query.typeId;
    },
  },
  created() {
    this.toGoodsType();
  },
  methods: {
    // 获取到该类型的价格跟数量
    getPriceAndNum(){
      GetGoodsPriceAndNum(this.queryData.typeId).then((res)=>{
        const resData = res.data.data
        this.typeDataTitle = {
          "price": resData.price,
          "num": resData.num,
        }
      })
    },
    //删除购物车处理
    delteCartGoods(sku) {
      //加载提示
      let loading = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      DeleteGoods2Carts(sku).then(() => {
        loading.close();
        this.$message.success("successfully deleted");
        this.getList();
        this.$emit("initCart");
      });
    },
    // 跳转商品详情
    toGoUrl(row) {
      let {
        href,
      }=this.$router.resolve({
        path: "/web/goodsDetail",
        query: {
          id: row.item_no,
        },
      });
      window.open(href);
    },
    // 获取推荐商品类型
    toGoodsType() {
      GetBuyType().then((res) => {
        const { error, data } = res.data;

        // 1. 判断url是否带参数，如果带参数，就根据参数显示对应的数据
        if (this.$route.query.typeId) {
          this.queryData.typeId = this.$route.query.typeId;
        } else {
          this.queryData.typeId = data[0].id;
        }
        this.typeData = data

        // 2. 循环数据，判断当前语言，显示对应的数据
        this.img3Fun();
      });
    },
    img3Fun() {
      let data = this.typeData
      let showTypeData = {};
      console.log(this.$i18n.locale)
      for (let i = 0; i < data.length; i++) {
        if (this.$i18n.locale == "zh-CN") {
          data[i]["nameX"] = data[i].name;
        } else {
          data[i]["nameX"] = data[i].name_en;
        }
        if (data[i].id == this.queryData.typeId) {
          showTypeData = data[i];
        }
      }
      this.typeList = data; // 所有列表
      // 3. 当前显示的数据
      if (this.showTypeData == {}) {
        this.showTypeData = data[0];
      } else {
        this.showTypeData = showTypeData;
      }
    },
    // 获取商品列表
    getList() {
      GetGoodsList({ id: this.queryData.typeId, page: this.queryData.page, size: this.queryData.pageSize }).then((res) => {
        const { error, data } = res.data;
        this.queryData.total = data.total;
        let fdata = this.filterGoods(data.data);
        this.goodsList = this.splitArrayTo2D(fdata, 3);
        this.img3Fun()
      });
    },
    //设定一个添加购物车的数据，用来绑定添加购物车的数量
    filterGoods(goodsData) {
      let resData = goodsData;
      for (let i = 0; i < resData.length; i++) {
        resData[i].addNum = resData[i].purchase_spec;
        resData[i].iconArr = resData[i].file_type_icon_list.split(",");
      }
      return resData;
    },
    splitArrayTo2D(arr, numPerGroup) {
      let result = [];
      let currentGroup = [];

      for (let i = 0; i < arr.length; i++) {
        currentGroup.push(arr[i]);

        if (currentGroup.length === numPerGroup || i === arr.length - 1) {
          result.push(currentGroup);
          currentGroup = [];
        }
      }

      return result;
    },
    // 显示图片列表
    showImgList() {
      let i1 = this.showTypeData["dis_img"].split(",");
      this.i1 = i1;
      let i2 = this.showTypeData["publictity_img"].split(",");
      this.i2 = i2;
      let i3 = this.showTypeData["display_rack_img"].split(",");
      this.i3 = i3;
      this.qty = this.showTypeData["qty"];
      this.subtotal = this.showTypeData["subtotal"].toFixed(2);
    },
    // 跳转链接
    tolink(tid) {
      // 跳转链接
      this.$router.push({ path: "/web/buy", query: { typeId: tid } });
    },
    //加入购物车
    addCarts(row) {
      // 判断用户是否为Guest
      const user = window.sessionStorage.getItem("webUser");
      const userArr = JSON.parse(user);
      if (userArr.user_info.username === 'Guest') {
        this.$message.warning(this.$t("guestalert"));
        return;
      }

      if (row.addNum % row.purchase_spec !== 0) {
        this.$message.error(this.$t("Please change in multiples of specifications"));
        this.$nextTick(() => {
          row.addNum = row.purchase_spec;
        });
      } else {
        //做一个加载提示
        let loadingInstance = Loading.service({
          text: this.$t("Loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        AddToCartByGoods(row.item_no, row.addNum, row.purchase_spec).then(() => {
          loadingInstance.close();
          this.$emit("initCart");
          this.getList();
        });
      }
    },
    // 全部加入购物车
    BuyAllToCart() {
      // 开启加载提示
      if (confirm(this.$t("Are you sure to add all to cart?"))) {
        const loadingInstance = Loading.service({
          text: "执行中，请稍候...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        AllToCart(this.showTypeData.id).then(() => {
          // 执行完成后关闭加载提示
          loadingInstance.close();
          // 提醒更新成功
          this.$message.success(this.$t("Added successfully"));
          this.$emit("initCart");
        });
      }
    },
    //复制商品条码
    onCopy: function() {
      this.$message.success("Product barcode copied to clipboard");
    },
    onError: function() {
      this.$message.success("Copy failed");
    },
    // 当前页跳转
    handleCurrentChange(val) {
      this.queryData.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* 头部分类样式 */
.disQueryUl {
  display: flex;
  width: 1400px;
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  flex-wrap: wrap;
}
.disQueryUl .title {
  font-weight: bold;
  font-size: 18px;
}
.disQueryUl li {
  font-size: 14px;
}
.disQueryUl span {
  text-align: center;
  font-size: 20px;
  margin-right: 25px;
  cursor: pointer;
  padding: 5px;
}
.disQueryUl .disli {
  text-align: center;
  color: #515a6e;
  font-size: 18px;
  margin-right: 18px;
  padding: 5px;
}
.disQueryUl .disli:hover {
  color: white;
  background: #238da5;
  cursor: pointer;
}
/* 高亮显示 */
.disQueryUl .hoverCls {
  color: white;
  background: #238da5;
}

/* 中间内容 */
.buy_conter {
  width: 1400px;
  padding-bottom: 20px;
  margin: 0 auto;
  display: flex;
}
.buy_conter_left {
  width: 355px;
  margin-right: 40px;
  height: auto;
}
.bcl_box {
  width: 355px;
  height: 280px;
  background: #f5f8fa;
  margin: 0 auto;
  margin-bottom: 20px;
}
.bcl_box .title {
  width: 335px;
  height: 40px;
  line-height: 40px;
  text-indent: 20px;
  color: #515a6e;
  margin: 0 auto;
}
.bcl_box_img {
  width: 335px;
  height: 230px;
  border: 1px solid white;
  margin: 0 auto;
}
/* 右侧 */
.buy_conter_right {
  width: 1005px;
}
.buy_conter_right_title {
  background: #f5f8fa;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #0090a1;
}
.buy_conter_right_title a {
  /* 添加下划线*/
  text-decoration: underline;
  font-size: 17px;
  margin-left: 15px;
}
.buy_conter_right ul {
  display: flex;
  margin-bottom: 20px;
}
.buy_conter_right ul li {
  border: 1px solid #ccc;
  background: #f5f8fa;
  margin-right: 34.5px;
  font-weight: 500;
}
.price_div{
  display: flex;
  justify-content: center;
}
.price_div p,
.add_to_cart,
.goods_name_div {
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
}
.add_num_div{
  text-align: center;
  padding-bottom: 5px;
}
.price{
  color: red;
}
.add_to_cart {
  color: #218da0;
  background: #ddedf0;
  margin-top: 3px;
  cursor: pointer;
  height: 43px;
  line-height: 43px;
  font-size: 16px;
  text-decoration: underline;
}
</style>
  